import { Card, Button } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";


/**
 * Card customization.
 */
const CardStyled = withStyles({
  root: {
    border: "solid 1px #000",
    minHeight: "225px",
    //backgroundImage: `url(${MailBox})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "60%",
    backgroundPosition: "right",
    width: 'auto',
  }
})(Card);

const ButtonCardStyled = withStyles({
  root: {
    fontSize: "1rem",
    fontWeight: "bold",
    "&:hover": {
      backgroundColor: "#FFF"
    }
  }
})(Button);

export { CardStyled, ButtonCardStyled } 


// WEBPACK FOOTER //
// ./src/components/common/postal-address/CardStyled.js